import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";

import { Redirect } from "react-router-dom";

import { register, isLoggedIn } from "../store/auth";

import { getGenders } from "../store/services/genders";
import moment from "moment";

import { connect } from "react-redux";

const USER_NAME = "Username";
const FIRST_NAME = "First name";
const LAST_NAME = "Last name";
const BIRTHDATE = "Birthdate";
const GENDER = "Gender";
const PASSWORD = "Password";
const REPEAT_PASSWORD = "Repeat password";

const REGISTER = "Register";

class RegisterForm extends Form {
  state = {
    data: {
      userName: "",
      firstName: "",
      lastName: "",
      birthdate: new Date(),
      gender: "",
      password: "",
      repeatPassword: "",
    },
    errors: {},
  };

  schema = {
    userName: Joi.string().min(1).max(128).required().label(USER_NAME),
    firstName: Joi.string().min(1).max(128).required().label(FIRST_NAME),
    lastName: Joi.string().min(1).max(128).required().label(LAST_NAME),
    // birthdate: Joi.date().max("now").required().label("Birthdate"),
    birthdate: Joi.date()
      .max(new Date().setDate(new Date().getDate() - 1))
      .required()
      .label(BIRTHDATE),
    gender: Joi.string().valid("M", "F").min(1).max(1).required().label(GENDER),
    //password must include at least 8 characters, 1 lowercase, 1 uppercase, and 1 digit
    password: Joi.string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]/)
      .min(8)
      .required()
      .options({
        language: {
          string: {
            regex: {
              base:
                "must contain a minimum of 8 characters, at least an uppercase, a lowercase, and a digit"
              },
          },
        },
      })
      .label(PASSWORD),
    repeatPassword: Joi.string().required().label(REPEAT_PASSWORD),
  };
  componentDidMount(){
    window.scrollTo(0, 0);
  }

  doSubmit = async () => {
    try {
      ///
      await this.props.register(this.state.data);
      this.props.history.replace({
        pathname: "/login",
      });
      ///
    } catch (e) {
      if (e.response && e.response.status === 400) {
        const errors = { ...this.state.erros };
        errors.userName = e.response.data;
        this.setState({ errors });
      }
    }
  };

  render() {
    if (isLoggedIn()) return <Redirect to="/" />;

    return (
      <div className="d-flex justify-content-center">
        <div className="w-100 p-4 mb-4 rounded shadow" style={{maxWidth:500}}>
          <h1>{REGISTER}</h1>
          <form onSubmit={this.handleSubmit}>
            {this.renderInput("userName", USER_NAME, false)}
            {this.renderInput("password", PASSWORD, false, "password")}
            {this.renderInput(
              "repeatPassword",
              REPEAT_PASSWORD,
              false,
              "password"
            )}
            {this.renderInput("firstName", FIRST_NAME, false)}
            {this.renderInput("lastName", LAST_NAME, false)}
            {this.renderDatePicker(
              "birthdate",
              BIRTHDATE,
              new Date(),
              false,
              function (current) {
                return current > moment().endOf("day");
              }
            )}
            {this.renderSelect("gender", GENDER, getGenders(), false)}

            {this.renderButton(REGISTER, false)}
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // currentUser: state.auth.currentUser,
  // token: state.auth.token,
});

const mapDispatchToProps = (dispatch) => ({
  register: (user) => dispatch(register(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);
